// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2nSYf","header":"PatientQuestionnaire_header__3mBmU","info":"PatientQuestionnaire_info__N8tAD"};